<template>
	<div class="container">
		<div class="content">
			<div v-if="isWishlist">
				<h3 class="center">Per vedere le ricette</h3>
				<h4 class="center">Accedi al tuo account o prosegui senza accedere</h4>
			</div>
			<br>
			<section class="login-page">
				<sign-in-content :emailLogin="true" @login-mail="login"/>
				
<!-- 				<CTA
					:content="`Accedi con Facebook`"
					:size="`small`"
					:color="`blue`"
          			class="tag-partner"
					@click="login('facebook')"
				/>

				<CTA
					:content="`Accedi con Bennet`"
					:size="`small`"
					:color="`green`"
          			v-if="$root.source == 'bennet'"
					@click="login('bennet')"
				/>

				<form id="login-page" @submit.prevent="login()">

					<div class='header-legend tag-partner'>
						<span> Oppure </span>
					</div>
					<div>
						<input type="email" name="email"  v-model="form.username" class="form-control" placeholder="E-mail" required="">
					</div> -->
					<!-- <div class="password">
						<input type="password" name="password"  v-model="form.password" class="form-control" placeholder="Password" required="">
					</div> -->

				<!-- 	<input-password
    					v-model="form.password"
   					/>
					<flash
						:flash="errorStore.message"
						state="error"
					/>
					<p class="text-right">
						<router-link :to="{ name: 'recovery'}" class="link-detail" title="Password dimenticata">Hai dimenticato la password?</router-link>
					</p>

					<CTA
						:content="`Accedi`"
						:size="`small`"
						isArrow
						type='submit'
					/>

				</form> -->
			</section>

			<div
				@click="skipLogin()"
				class="center skip link-detail"
				v-if="isWishlist"
				v-html="`Prosegui senza accedere >`"
			/>
			
		</div>
	</div>
</template>

<script type = "text/javascript" >

import { getParameterByName } from '../assets/js/main'
import { errorStore } from '../store/errorStore'
import { container } from '../services/container'
import { User } from '../core/User'

import InputPassword from './Parts/InputPassword'
import Flash from './Parts/Flash'
import SignInContent from './SignInContent'

export default {
	data () {
		return {
			form: {},
			
			isWishlist: false,
			errorStore: errorStore.state
		}
	},

	components: {
		InputPassword,
		Flash,
		SignInContent
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		login (provider) {
			if (provider) {
				var redir = getParameterByName('redir')	
				var redirectUrl = ''

				if (redir === 'supporto') redirectUrl = 'supporto'
				if (redir === 'payment') redirectUrl = 'user/profile/payment'
				if (redir === 'profile') redirectUrl = 'user/profile/orders'
				if (redir === 'next-order') redirectUrl = 'user/profile/next-order'
				if (redir === 'shipment') redirectUrl = 'user/profile/cambia-indirizzo'
				if (redir === 'gift') redirectUrl = 'my-quomi#gift'
				if (redir === 'subscription') redirectUrl = 'user/profile/subscription'
				if (this.isWishlist) redirectUrl = 'ricette'
				container.get('services.oauth').providerSignIn(provider, {}, '/' + redirectUrl)
			} else {
				container.get('services.oauth').signIn(this.form)
				errorStore.removeMessage()
				.then(() => {
					return container.get('services.oauth').authenticate()
				}) 
				.then(response => {
					this.$root.updateUser(new User(response.body.data.resource)) 
					this.goAhead()
				})
				.catch(response => {
					errorStore.formatMessage(response)
				})
			}
		},

		goAhead () {
			var redir = getParameterByName('redir')

			if (redir === 'payment') {
				this.$router.push({name: 'profile_payment'})
				return
			}

			if (redir === 'shipment') {
				this.$router.push({name: 'profile_shipment'})
				return
			}

			if (redir === 'profile') {
				this.$router.push({name: 'profile_orders'})
				return
			}

			if (redir === 'next-order') {
				this.$router.push({name: 'profile_next-order'})
				return
			}

			if (redir === 'gift') {
				this.$router.push({name: 'dashboard', params: { slug: 'gift' } })
				return
			}

			if (redir === 'supporto') {
				this.$router.push({name: 'freshdesk'})
				return
			}

			if (redir === 'subscription') {
				this.$router.push({name: 'profile_subscription'})
				return
			}

			if (this.isWishlist) {
				this.$router.push({name: 'recipes'})
				return
			}

			this.$router.push({ name: 'flow-new' })
		},

		skipLogin () {
			this.$router.push({ name: 'recipes' })
		}
	},

	created () {
		/* if (getParameterByName('chosen_recipes')) {
			var store = window.sessionStorage
			store.setItem('chosen_recipes', getParameterByName('chosen_recipes'))
			this.isWishlist = true
			this.$router.replace({ name: this.$route.name })
		} */
		if (this.user && !this.user.email.includes('guest.quomi.it')) {
			this.goAhead()
		}
	}

}

</script>

<style scoped>

.login-page {
	width: 98%;
	max-width: 500px;
	padding: 30px;
	margin: 0px auto;
	border: 1px solid white;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
}

.login-page input {
	padding: 6px;
}

.header-legend {
	border-top:1px solid #EEE;
	margin:30px 0 10px 0;
	text-align:center;
	font-size: 15px;
}

.header-legend > * {
	position:relative;
	top:-13px;
	background: #ffffff;
	padding:0 15px;
}

#login-page label {
	font-size: 13px;
	font-weight: normal;
	cursor: pointer;
}

#login-page button[disabled="disabled"] {
	background-color: grey;
}

.btn {
	width: 100%;
}

.skip {
	margin: 20px 0;
}

</style>
